"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardFooter = exports.StyledCardBody = exports.StyledCardHeader = exports.StyledCard = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Props_1 = require("../../shared/Props");
const Responsive_1 = require("../../shared/Responsive");
// The problem: JSDOM uses a third-party CSS selector engine called nwsapi,
// and it doesn't support the :has() selector. This causes Jest tests to fail when parsing styles.
//
// The solution: We check if the environment is 'test' and conditionally exclude styles
// using :has() to ensure Jest can run tests without encountering syntax errors.
const isTestEnv = process.env.NODE_ENV === "test";
exports.StyledCard = styled_components_1.default.div `
    background-color: var(--ds-color-white);
    border: 1px solid var(--ds-color-silver);
    border-radius: var(--ds-border-radius);

    ${({ $appearance }) => $appearance === "elevated" &&
    (0, styled_components_1.css) `
            box-shadow: 0 2px 0 0 var(--ds-color-silver);
        `}

    ${({ $height }) => $height && (0, Responsive_1.responsiveCssToMedia)($height, "height")}
`;
exports.StyledCardHeader = styled_components_1.default.div `
    border-top-left-radius: var(--ds-border-radius);
    border-top-right-radius: var(--ds-border-radius);
    padding: 0.75rem 1rem;

    ${!isTestEnv &&
    (0, styled_components_1.css) `
        :has(+ *) {
            border-bottom: 1px solid var(--ds-color-silver);
        }
    `}

    ${({ $backgroundColor }) => {
    return ($backgroundColor &&
        (0, Props_1.isGreyscaleColor)($backgroundColor) &&
        (0, styled_components_1.css) `
                background-color: var(--ds-color-${$backgroundColor});
            `);
}}

    ${({ $p }) => {
    return $p && (0, Responsive_1.responsiveCssToMedia)($p, "padding");
}}

    ${({ $px }) => {
    return ($px && Object.assign(Object.assign({}, (0, Responsive_1.responsiveCssToMedia)($px, "padding-left")), (0, Responsive_1.responsiveCssToMedia)($px, "padding-right")));
}}

    ${({ $py }) => {
    return ($py && Object.assign(Object.assign({}, (0, Responsive_1.responsiveCssToMedia)($py, "padding-top")), (0, Responsive_1.responsiveCssToMedia)($py, "padding-bottom")));
}}

    ${({ $pt }) => {
    return $pt && (0, Responsive_1.responsiveCssToMedia)($pt, "padding-top");
}}

    ${({ $pr }) => {
    return $pr && (0, Responsive_1.responsiveCssToMedia)($pr, "padding-right");
}}

    ${({ $pb }) => {
    return $pb && (0, Responsive_1.responsiveCssToMedia)($pb, "padding-bottom");
}}

    ${({ $pl }) => {
    return $pl && (0, Responsive_1.responsiveCssToMedia)($pl, "padding-left");
}}
`;
exports.StyledCardBody = styled_components_1.default.div `
    padding: 1rem;

    ${!isTestEnv &&
    (0, styled_components_1.css) `
        :has(+ *) {
            border-bottom: 1px solid var(--ds-color-silver);
        }
    `}

    ${({ $p }) => {
    return $p && (0, Responsive_1.responsiveCssToMedia)($p, "padding");
}}

    ${({ $px }) => {
    return ($px && Object.assign(Object.assign({}, (0, Responsive_1.responsiveCssToMedia)($px, "padding-left")), (0, Responsive_1.responsiveCssToMedia)($px, "padding-right")));
}}

    ${({ $py }) => {
    return ($py && Object.assign(Object.assign({}, (0, Responsive_1.responsiveCssToMedia)($py, "padding-top")), (0, Responsive_1.responsiveCssToMedia)($py, "padding-bottom")));
}}

    ${({ $pt }) => {
    return $pt && (0, Responsive_1.responsiveCssToMedia)($pt, "padding-top");
}}

    ${({ $pr }) => {
    return $pr && (0, Responsive_1.responsiveCssToMedia)($pr, "padding-right");
}}

    ${({ $pb }) => {
    return $pb && (0, Responsive_1.responsiveCssToMedia)($pb, "padding-bottom");
}}

    ${({ $pl }) => {
    return $pl && (0, Responsive_1.responsiveCssToMedia)($pl, "padding-left");
}}
`;
exports.StyledCardFooter = styled_components_1.default.div `
    padding: 0.75rem 1rem;

    ${({ $p }) => {
    return $p && (0, Responsive_1.responsiveCssToMedia)($p, "padding");
}}

    ${({ $px }) => {
    return ($px && Object.assign(Object.assign({}, (0, Responsive_1.responsiveCssToMedia)($px, "padding-left")), (0, Responsive_1.responsiveCssToMedia)($px, "padding-right")));
}}

    ${({ $py }) => {
    return ($py && Object.assign(Object.assign({}, (0, Responsive_1.responsiveCssToMedia)($py, "padding-top")), (0, Responsive_1.responsiveCssToMedia)($py, "padding-bottom")));
}}

    ${({ $pt }) => {
    return $pt && (0, Responsive_1.responsiveCssToMedia)($pt, "padding-top");
}}

    ${({ $pr }) => {
    return $pr && (0, Responsive_1.responsiveCssToMedia)($pr, "padding-right");
}}

    ${({ $pb }) => {
    return $pb && (0, Responsive_1.responsiveCssToMedia)($pb, "padding-bottom");
}}

    ${({ $pl }) => {
    return $pl && (0, Responsive_1.responsiveCssToMedia)($pl, "padding-left");
}}
`;
//# sourceMappingURL=Card.styles.js.map